import React from 'react'
import styles from './style.module.css'
import Button from '../Button/Button'
import Automate_and_accelerate from '../../assets/images/Automate_and_accelerate.svg'
import Increase_the_visibility from '../../assets/images/Increase_the_visibility.svg'
import Improve_the_quality from '../../assets/images/Improve_the_quality.svg'
import Boost_your_brand from '../../assets/images/Boost_your_brand.svg'
const features = [
  {
    icon: 'rocket_launch',
    svg: Automate_and_accelerate,
    title: 'Streamline your interview preparation.',
    subtitle: 'your entire hiring workflow.',
  },
  {
    icon: 'visibility',
    svg: Increase_the_visibility,
    title: 'Ensure consistency across interviews',
    subtitle: 'of your job posts.',
  },
  {
    icon: '',
    svg: Improve_the_quality,
    title: 'Improve candidate assessment accuracy.',
    subtitle: 'applicants from day one.',
  },
  {
    icon: 'hub',
    svg: Boost_your_brand,
    title: 'Reduce time-to-hire',
    subtitle: 'inclusive, professional postings.',
  },
]
const handleScrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
}
const AiJobInterviewSection = () => {
  return (
    <div className={styles.wrapper}>
      <h2 className={styles.headingPrimary}>Enhance Your Interview Process?</h2>
      <h3 className={styles.headingSecondary}>
        Start using Recooty’s AI Interview Question Generator to:
      </h3>

      <div className={styles.featuresGrid}>
        {features.map((feature, index) => (
          <div className={styles.featureBox} key={index}>
            <div className={styles.iconCircle}>
              {/* <span className="material-symbols-round">{feature.icon}</span> */}
              <img src={feature.svg} alt={feature.title} />
            </div>
            <h4 className={styles.featureTitle}>{feature.title}</h4>
            {/* <p className={styles.featureSubtitle}>{feature.subtitle}</p> */}
          </div>
        ))}
      </div>

      <p className={styles.descriptionText}>
        Say goodbye to copy-pasting outdated templates. It’s time for smart,
        effective, <br />
        <strong>AI-generated Interview Question.</strong>
      </p>
      <Button
        variant="HeroButton"
        rightIcon="arrow_forward"
        onClick={() => handleScrollToTop()}
      >
        <span className={styles.btnText}>
        Try our free AI Interview Question Generator now!

        </span>
      </Button>
      <p className={styles.noteText}>
        No credit card required. No clutter. Just better, faster hiring.
      </p>
    </div>
  )
}

export default AiJobInterviewSection
